import { useState, useEffect, useCallback, useRef } from 'react';
export function useRecipeTimer(onComplete) {
    const [seconds, setSeconds] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const onCompleteRef = useRef(onComplete);
    useEffect(() => {
        onCompleteRef.current = onComplete;
    }, [onComplete]);
    useEffect(() => {
        if (!isRunning || seconds <= 0)
            return;
        const interval = setInterval(() => {
            setSeconds((s) => {
                if (s <= 1) {
                    setIsRunning(false);
                    onCompleteRef.current?.();
                    return 0;
                }
                return s - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [isRunning]);
    const start = useCallback((durationSeconds) => {
        setSeconds(durationSeconds);
        setIsRunning(true);
    }, []);
    const pause = useCallback(() => {
        setIsRunning(false);
    }, []);
    const resume = useCallback(() => {
        if (seconds > 0) {
            setIsRunning(true);
        }
    }, [seconds]);
    const cancel = useCallback(() => {
        setIsRunning(false);
        setSeconds(0);
    }, []);
    const formatTime = useCallback(() => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    }, [seconds]);
    return {
        seconds,
        isRunning,
        start,
        pause,
        resume,
        cancel,
        formatTime,
    };
}
